// extracted by mini-css-extract-plugin
export default {"basicKeyRow":"bJW8s80G","expandedKeyRow":"O69jJ0HB bJW8s80G","titleKeyRow":"g298bsCm bJW8s80G","spaceBasicRow":"OU7K9UCE","spaceTitleRow":"HhWixTlO"};